import type { UseQueryResult } from '@tanstack/react-query';
import type { CompanyStatementGQL } from '@/hooks/useCompanyStatementsGQL/queryFn';
import useCompanyStatementsGQL from '../useCompanyStatementsGQL';

/**
 * This hook returns the formatted statements for the given company,
 * You can optionally specify which statement names to filter by
 */
const useCompanyStatementsGQLFormatted = <
  Names extends Readonly<string[]> = Readonly<string[]>,
  StatementsMap = Record<Names[number], CompanyStatementGQL>
>({
  canonicalURL,
  names,
}: {
  canonicalURL: string;
  names?: Names;
}): UseQueryResult<StatementsMap, unknown> => {
  const query = useCompanyStatementsGQL({
    canonicalURL,
    names,
    options: {
      select: (data) => {
        if (!data) return {} as StatementsMap;
        return data.statements.reduce((prev, curr) => {
          prev[curr.name] = curr;
          return prev;
        }, {}) as StatementsMap;
      },
    },
  });

  return query;
};
export default useCompanyStatementsGQLFormatted;
